/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const APP_START_INITIALIZATION = "APP_START_INITIALIZATION";
export const APP_FINISH_INITIALIZATION = "APP_FINISH_INITIALIZATION";
export const SET_APP_GLOBAL_ERROR = "SET_APP_GLOBAL_ERROR";
